import { DashboardOverview } from '@/components/dashboard/DashboardOverview';

export default function HostDashboard() {
  return <DashboardOverview />;
}
